// extracted by mini-css-extract-plugin
export default {"assambledCongratz":"Success_assambledCongratz__QCtia"};